import type { MessageFunction } from 'vue-i18n';
import homepage from './pages/homepage/index';
import tech from './pages/tech/index';
import statistics from './pages/statistics/index';
import Info from './pages/info/index';
import system from './pages/system/index';
// 挪威博克马尔
export default {
    license: {
        powered_by: 'SAIC Motor International {\'|\'} Alle rettigheter reservert',
    },
    auth: {
        login: 'Logg inn',
        username: 'Brukernavn',
        username_placeholder: 'Skriv inn brukernavn',
        password: 'Passord',
        password_placeholder: 'Skriv inn passord',
        code: 'Bekreftelseskode',
        code_placeholder: 'Skriv inn bekreftelseskode',
        logout: 'Logg ut',
        logout_success: 'Du er nå logget ut',
        day: 'dag',
        password_expiration: 'Passordets gyldighet er utløpt – vennligst endre det',
        expire: 'Gjenstående tid før passord utløper',
        conseils:
            'Må inneholde store bokstaver, små bokstaver, tall og spesialtegn ({msg}). Passordlengden må være mellom 8 og 16 tegn.',
        brand_Selection: 'Merkevalg',
        unread_notices: 'Uleste meldinger',
        new_cases: 'Nye saker',
        unanswered_cases: 'Ubesvarte saker',
        overdue_cases: 'Forsinkede saker',
    },
    button: {
        query: 'Spørre',
        editing_position: 'Rediger stilling',
        show_theme_editor: 'Vis / skjul temaredigering',
        change_password: 'Endre passord',
        old_password: 'Gammelt passord',
        new_password: 'Nytt passord',
        confirm_password: 'Bekreft passord',
        button: 'Knapp',
        about: 'Om',
        back: 'Tilbake',
        go: 'OK',
        home: 'Hjem',
        confirm: 'Bekreft',
        modify: 'Endre',
        edit: 'Rediger',
        new: 'Ny',
        cancel: 'Avbryt',
        close: 'Lukk',
        search: 'Søk',
        reset: 'Tilbakestill',
        delete: 'Slett',
        add: 'Legg til',
        collapse: 'Skjul',
        expand: 'Vis',
        download_template: 'Last ned mal',
        batch_import: 'Masseimport',
        import: 'Importer',
        export: 'Eksporter',
        export_fail: 'Importen mislyktes',
        detailed: 'Detaljer',
        details: 'Detaljer',
        download: 'Last ned',
        toView: 'Se',
        toViews: 'Se bilder',
        uploadAttachments: 'Last opp vedlegg',
        selectFile: 'Velg fil',
        fillingInstructions: 'Instruksjoner for utfylling',
        release: 'Publiser',
        release_recall: 'Trekke tilbake publisering',
        save: 'Lagre',
        send: 'Send',
        tips: 'Tips',
        send_back: 'Send tilbake',
        examine: 'Kontroller',
        void: 'Annuller',
        more: 'Mer',
        refresh: 'Oppdater',
        selects: 'Velg',
        serial_number: 'Serienummer',
        upload_progress: 'Opplastingsfremgang',
        invalid: 'Ugyldig',
        daily_record: 'Daglig logg',
        operation_type: 'Operasjonstype',
        field_name: 'Feltnavn',
        edit_role: 'Rediger rolle',
        user_role: 'Velg rolle',
        assignment_role: 'Rolle',
        post: 'Stilling',
        sending: 'Sender...',
        reset_password: 'Tilbakestill passord',
        display_or_not: 'Vis eller ikke',
        document: 'Dokument',
        specificTemplates: 'Spesifikke maler',
        transferOrder: 'Overfør ordre',
        forwarding: 'Videresend',
        one_click_notification: 'Varsling med ett klikk',
        english_export: 'Eksport på engelsk',
        oneclick_download: 'Nedlasting med ett klikk',
        passwordmsga:
            'Må inneholde store bokstaver, små bokstaver, tall og spesialtegn (@\\$!_~\\&*)',
        passwordmsgb: 'Passordlengden må være mellom 8 og 16 tegn',
        passwordmsgc: 'Kan ikke være identisk med noen av de seks forrige passordene',
        export_file_list: 'Liste over eksporterte filer',
        personal_center: 'Personlig senter',
        upload_list: 'Opplastingsliste',
        clear_completed: 'Fjern fullførte',
    },
    radio: {
        enabled: 'Aktivert',
        disabled: 'Deaktivert',
        catalogue: 'Katalog',
        individual: 'Individuell',
        all: 'Alle',
        yes: 'Ja',
        no: 'Nei',
    },
    dropdown: {
        close_others: 'Lukk andre',
        close_right: 'Lukk til høyre',
        close_left: 'Lukk til venstre',
    },
    table: {
        action: 'Handling',
        explain: 'Forklaring',
        fileName: 'Filnavn',
        size: 'Størrelse (MB)',
        uploader: 'Lastet opp av',
        uploadTime: 'Opplastingstidspunkt',
        system: 'System',
        caption: 'Overskrift',
        categorization: 'Kategorisering',
        link: 'Lenke',
        forwarding_time: 'Videresendingstidspunkt',
        forwarder: 'Videresendt av',
        send_to: 'Send til',
        mode: 'Modus',
    },
    pagination: {
        pages: ({ named }: Parameters<MessageFunction>[0]) => `Side ${named('number')}`,
        total: ({ named }: Parameters<MessageFunction>[0]) =>
            `Totalt ${named('number')} oppføringer`,
        vinCount: ({ named }: Parameters<MessageFunction>[0]) =>
            `Totalt ${named('number')} kjøretøy`,
    },
    confirm: {
        confirm_deletion: 'Bekreft sletting?',
        confirm_void: 'Bekreft annullering?',
        confirm_release: 'Bekreft publisering?',
        ack: 'Bekreft',
        cancel: 'Avbryt',
        non_records: 'Velg minst én oppføring',
    },
    request: {
        failed_placeholder: 'Forespørsel mislyktes – serverfeil',
        success_placeholder: 'Forespørsel vellykket',
        auth: {
            login_success: 'Innlogging vellykket',
        },
        error: {
            '404': 'Ressursen ble ikke funnet',
            '403': 'Utilstrekkelige rettigheter',
        },
    },
    page: {
        global: {
            page_search: 'Søk på siden',
        },
        error: {
            not_found: 'Siden ble ikke funnet',
            not_found_des: 'Ingenting her',
            auth_failed: 'Utilstrekkelige rettigheter',
            auth_failed_des: 'Denne siden er forbudt',
            file_format_error: 'Ugyldig filformat!',
            preview_failed: 'Forhåndsvisning mislyktes! Filen er ødelagt!',
        },
        homepage: {
            homepage: homepage.homepage.nbNO,
        },
        system: {
            menu: system.menu.nbNO,
            dict: system.dict.nbNO,
            dept: system.dept.nbNO,
            role: system.role.nbNO,
            user: system.user.nbNO,
        },
        info: {
            announcement: Info.announcement.announcement.nbNO,
            document: Info.document.document.nbNO,
        },
        tech: {
            quality: {
                problemTracking: tech.quality.problemTracking.nbNO,
                recallActivity: tech.quality.recallActivity.nbNO,
                abnormalClaimTracking: tech.quality.abnormalClaimTracking.nbNO,
            },
            management: {
                inquiryOd: tech.management.inquiry.nbNO,
                permission: tech.management.permission.nbNO,
                onSiteSupportHq: tech.management.onSiteSupport.nbNO,
                progHistoryHq: tech.management.progHistory.nbNO,
                salesRecordHq: tech.management.salesRecord.nbNO,
                vehicleInfoHq: tech.management.vehicleInfo.nbNO,
                claimHq: tech.management.claim.nbNO,
                filterHq: tech.management.filter.nbNO,
                newCarlssue: tech.management.newCarIssue.nbNO,
                newCarDefinition: tech.management.newCarDefinition.nbNO,
                vehicleProductionInfo: tech.management.vehicleProductionInfo.nbNO,
                programmingHistoryInformationQuery:
                    tech.management.programmingHistoryInformationQuery.nbNO,
                ecuControllerInformationQuery: tech.management.ecuControllerInformationQuery.nbNO,
            },
        },
        components: {
            businessComponents: tech.management.businessComponents.nbNO,
        },
        statistics: statistics.inquiryStatistics.nbNO,
        systemClassifyA: statistics.systemClassifyA.nbNO,
        systemClassifyB: statistics.systemClassifyB.nbNO,
        engineerStatistics: statistics.engineerStatistics.nbNO,
        defectivePart: statistics.defectivePart.nbNO,
        replyInquiryStatistics: statistics.replyInquiryStatistics.nbNO,
        passRateStatistics: statistics.passRateStatistics.nbNO,
        timelyResponseRateStatistics: statistics.timelyResponseRateStatistics.nbNO,
        responseRateStatistics24Hour: statistics.responseRateStatistics24Hour.nbNO,
        customsClearance135Rate: statistics.customsClearance135Rate.nbNO,
        accumulatedClosureRate: statistics.accumulatedClosureRate.nbNO,
        engineerAffiliatedOrganization: statistics.engineerAffiliatedOrganization.nbNO,
        EngineerResponseRateReport: statistics.EngineerResponseRateReport.nbNO,
    },
    validation: {
        common: {
            required: 'Dette feltet er obligatorisk',
            numeric: 'Må være et heltall',
            decimal: 'Må være et tall',
            positive_interger: 'Må være et positivt heltall',
            up_to_digits: ({ named }: Parameters<MessageFunction>[0]) =>
                `Maksimalt ${named('number')} siffer`,
            more_than_characters: ({ named }: Parameters<MessageFunction>[0]) =>
                `Maks ${named('number')} tegn tillatt`,
            max_bytes: ({ named }: Parameters<MessageFunction>[0]) =>
                `Maks antall tegn overskredet (${named('number')})`,
            less_than_characters: ({ named }: Parameters<MessageFunction>[0]) =>
                `Må være minst ${named('number')} tegn`,
            must_be_characters: ({ named }: Parameters<MessageFunction>[0]) =>
                `Må være nøyaktig ${named('number')} tegn`,
            greater_than: ({ named }: Parameters<MessageFunction>[0]) =>
                `Kan ikke være større enn ${named('number')}`,
            less_than: ({ named }: Parameters<MessageFunction>[0]) =>
                `Kan ikke være mindre enn ${named('number')}`,
            up_to_2_decimal_places: 'Maks to desimaler',
            retain_up: 'Maks 10 siffer før komma, maks 2 etter',
            retain_ups: 'Maks 11 siffer før komma, maks 4 etter',
            input_number: 'Skriv inn arabiske tall',
            only_number_a: 'Kun bokstaver eller tall tillatt',
            translate: 'Kun bokstaver tillatt',
            positive_integer: 'Fyll ut minst ett felt',
            at_least_one: 'Fyll ut minst ett',
        },
        tip: {
            incomplete_information: 'Informasjonen er ikke fullstendig',
        },
    },
    import: {
        template_file: 'Mal-fil',
        browse: 'Bla gjennom',
        download_template: 'Last ned mal',
        no_file_selected: 'Ingen fil valgt',
        incorrect_file_type: 'Ugyldig filtype',
        exceed: 'Grensen overskredet',
        upload_success: 'Opplasting vellykket',
        upload_fail: 'Opplasting mislyktes',
        again_upload: 'Kun bilder i formatene jpg, png, bmp eller gif kan lastes opp. Prøv igjen.',
        attachmentUpload: 'Last opp vedlegg',
        otherAttachmentUpload: 'Last opp andre vedlegg',
        supportedFormats: 'Støttede formater',
        preview: 'Forhåndsvisning',
    },
    export: {
        noDataToExport: 'Ingen data å eksportere',
    },
    select: {
        all: 'Alle',
    },
    checkbox: {
        select_all: 'Velg alle',
    },
    dialog: {
        error_message: 'Feilmelding',
        one_year: 'Du kan maksimalt eksportere ett års data om gangen',
    },
    ymd: {
        year: 'år',
        month: 'måned',
        day: 'dag',
        week: 'uke',
        january: 'Januar',
        february: 'Februar',
        march: 'Mars',
        april: 'April',
        may: 'Mai',
        june: 'Juni',
        july: 'Juli',
        august: 'August',
        september: 'September',
        october: 'Oktober',
        november: 'November',
        december: 'Desember',
    },
};
